export class Purchase {
  constructor(props = {}) {
    this.id = props.id
    this.price = props.price
    this.item = props.item
    this.purchaseDate = props.purchaseDate
  }
}

export class PaygentFormData {
  constructor(props = {}) {
    this.tradingId = props.tradingId
    this.merchantId = props.merchantId
    this.hash = props.hash
  }
}
